import React, { useState, createContext, useMemo } from "react";

export const PatientIntakeContext = createContext();

export const PatientIntakeProvider = (props) => {
    const [page, setPage] = useState(0);
    const [secureId, setSecureId] = useState("");
    const [secureToken, setSecureToken] = useState("");
    const [intakeInfo, setIntakeInfo] = useState({
        validation: {
            firstName: "",
            lastName: "",
            email: "",
            dob: ""
        },
        insurance: {
            FrontImage: null,
            FrontImageName: null,
            FrontImageType: null,
            BackImage: null,
            BackImageName: null,
            BackImageType: null
        }
    });
    const [docs, setDocs] = useState([])

    const nextPage = () => {
        setPage(page + 1);
    };

    const setPageNum = (num) => {
        setPage(num);
    };

    const prevPage = () => {
        setPage(page - 1);
    };

    const handleChange = (prop) => (event) => {
        setIntakeInfo({ ...intakeInfo, [prop]: event.target.value });
    };

    const setValidationInfo = (prop, value) => {
        setIntakeInfo({
            ...intakeInfo,
            validation: { ...intakeInfo.validation, [prop]: value }
        });
    };

    const setInsuranceInfo = (prop, value) => {
        setIntakeInfo({
            ...intakeInfo,
            insurance: { ...intakeInfo.insurance, [prop]: value }
        });
    };

    const updateInsuranceInfo = (updatedInsuranceInfo) => {
        setIntakeInfo(prevIntakeInfo => ({
            ...prevIntakeInfo,
            insurance: { ...prevIntakeInfo.insurance,  ...updatedInsuranceInfo }
        }));
    }

    const value = useMemo(
        () => ({
            page,
            nextPage,
            prevPage,
            setPageNum,
            intakeInfo,
            handleChange,
            setValidationInfo,
            setInsuranceInfo,
            secureId,
            setSecureId,
            secureToken,
            setSecureToken,
            updateInsuranceInfo,
            docs,
            setDocs
        }),
        [page, intakeInfo, nextPage, docs]
    );
    
    return (
        <PatientIntakeContext.Provider value={value}>
            {props.children}
        </PatientIntakeContext.Provider>
    );
};
